var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "setting" },
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "header flex align-center justify-between" }, [
          _c("a", { staticClass: "pointer title mar-r5" }, [
            _c("span", [_vm._v("网店助手")])
          ]),
          _c(
            "div",
            { staticClass: "pointer flex items-center" },
            [
              _c("img", {
                attrs: {
                  src:
                    "https://nfs.nxin.com/cms_image_02128766-9b82-470c-b555-b177a4bc8473.png",
                  height: "16"
                },
                on: { click: _vm.contactService }
              }),
              _c(
                "div",
                {
                  staticClass: "mar5-l f12 gray3",
                  on: { click: _vm.contactService }
                },
                [_vm._v("联系客服")]
              ),
              _c(
                "el-popover",
                {
                  ref: "tradeStoreSwitch",
                  attrs: {
                    placement: "bottom",
                    trigger: "click",
                    "popper-class": "gray6 trade-store-list"
                  }
                },
                [
                  _c(
                    "ul",
                    { staticClass: "ul-cls" },
                    _vm._l(_vm.shopList, function(item) {
                      return _c(
                        "li",
                        {
                          key: item.shopIdStr,
                          class: { active: item.isDefault },
                          on: {
                            click: function($event) {
                              return _vm.updateDefaultShop(item.shopIdStr)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.name) +
                              "\n            "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              ),
              _c(
                "el-tooltip",
                { attrs: { content: "切换店铺", placement: "top" } },
                [
                  _vm.shopList.length > 1
                    ? _c("i", {
                        directives: [
                          {
                            name: "popover",
                            rawName: "v-popover:tradeStoreSwitch",
                            arg: "tradeStoreSwitch"
                          }
                        ],
                        staticClass: "el-icon-s-shop blue mar10-l f22"
                      })
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "flex pad30 pad0-right h320",
          class: { settingNone: !_vm.isClick }
        },
        [
          _c("div", { staticClass: "flex-auto" }, [
            _c(
              "ul",
              { staticClass: "ul-cls flex general-store" },
              [
                _vm._l(_vm.list, function(item, index) {
                  return [
                    _c(
                      "li",
                      {
                        key: item.type,
                        staticClass:
                          "flex items-center justify-center flex-column",
                        class: { "store-active": _vm.switchType == item.type },
                        on: {
                          click: function($event) {
                            return _vm.toAssistantSwitch(item.type, index)
                          }
                        }
                      },
                      [
                        _vm.isClick
                          ? _c("img", { attrs: { src: item.img } })
                          : _c("img", { attrs: { src: item.imgNo } }),
                        _c("div", [_vm._v(_vm._s(item.name))])
                      ]
                    )
                  ]
                })
              ],
              2
            ),
            _c(
              "ul",
              { staticClass: "mar20-t ul-cls general-step flex" },
              _vm._l(_vm.list[_vm.stepIndex].step, function(item, index) {
                return _c("li", { key: index }, [
                  _c("div", { staticClass: "f16 fb pad10-b" }, [
                    _vm._v(_vm._s(item.head))
                  ]),
                  _c("div", { staticClass: "gray9 mar10-b lin25 h50" }, [
                    _vm._v(_vm._s(item.des))
                  ]),
                  _vm.isClick
                    ? _c(
                        "div",
                        {
                          staticClass: "blue pointer",
                          on: {
                            click: function($event) {
                              return _vm.$openHome(
                                item.url,
                                item.title,
                                item.target,
                                _vm.isClick
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(item.clickName) + " >")]
                      )
                    : _c(
                        "div",
                        { staticClass: "flex items-center" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                placement: "bottom",
                                effect: "dark",
                                content: _vm.tooltip
                              }
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline mar5-r pointer"
                              })
                            ]
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                !_vm.shopId || _vm.defaultShop.audit !== 1
                                  ? "暂无店铺"
                                  : "暂无设置权限"
                              )
                            )
                          ])
                        ],
                        1
                      )
                ])
              }),
              0
            )
          ]),
          _c(
            "div",
            { staticClass: "flex justify-center w300 bor-de-left" },
            [
              _vm.isClick
                ? [
                    _vm.shopDtlEntity.shopSort == "ORDER_GOODS"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-auto flex-column bor_radius_10 shop_info"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-auto flex-column items-center justify-center padd30"
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "gray_3 f18 mar20-b t_center"
                                  },
                                  [_vm._v(_vm._s(_vm.shopInfo.name))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-column flex_ver_center mar10-b"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "gray_6 f14 flex_1 lin_20 mar10-b"
                                      },
                                      [
                                        _vm._v(
                                          "扫码进入小程序，推荐给您的客户，您的客户将在小程序上进行采购"
                                        )
                                      ]
                                    ),
                                    _c("img", {
                                      staticClass: "wx_code",
                                      attrs: {
                                        src:
                                          "https://filesouthcdn.nxin.com/nxsc_173019846074307706381249643669.JPEG"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "p",
                                  { staticClass: "clear gray_6 f14 lin_20" },
                                  [
                                    _c("span", { staticClass: "float-left" }, [
                                      _vm._v("主营：")
                                    ]),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "float-left ellipsis_two w290"
                                      },
                                      [_vm._v(_vm._s(_vm.businesScope))]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "flex flex-auto flex-column shop_info"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-auto flex-column items-center justify-center padd30"
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "gray_3 f18 mar30_b t_center"
                                  },
                                  [_vm._v(_vm._s(_vm.shopInfo.name))]
                                ),
                                _vm.appletInfo && _vm.appletInfo.appId != ""
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-column items-center justify-center mar10_b"
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "wx_code",
                                          attrs: { src: _vm.authUrl }
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "text-center mar10-t"
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "gray_6 f14" },
                                              [
                                                _vm._v(
                                                  "扫码进入小程序，推荐给您的客户"
                                                )
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              { staticClass: "gray_6 f14" },
                                              [
                                                _vm._v(
                                                  "您的客户将在小程序上进行采购"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex flex_ver_center mar15_b"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "gray_6 f14 flex_1 lin_25 t_center"
                                              },
                                              [
                                                _vm._v(
                                                  "开通企业专属、独立品牌微信小程序"
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "medium"
                                            },
                                            on: { click: _vm.toWeiXinPage }
                                          },
                                          [_vm._v(" 立即开通 ")]
                                        )
                                      ],
                                      1
                                    )
                              ]
                            )
                          ]
                        )
                  ]
                : _c(
                    "div",
                    { staticClass: "flex flex-auto flex-column shop_info" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-auto flex-column items-center justify-center padd30"
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "gray_3 f18 mar30_b t_center" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    !_vm.shopId
                                      ? "暂无店铺"
                                      : _vm.defaultShop.name
                                  ) +
                                  "\n          "
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "flex flex_ver_center mar15_b" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "gray_6 f14 flex_1 lin_25 t_center"
                                },
                                [_vm._v("开通企业专属、独立品牌微信小程序")]
                              )
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                placement: "bottom",
                                effect: "dark",
                                content: _vm.tooltip
                              }
                            },
                            [
                              !_vm.shopId && !_vm.hideOpenShop
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "medium"
                                      },
                                      on: { click: _vm.toSetUp }
                                    },
                                    [_vm._v("立即开店")]
                                  )
                                : _vm.defaultShop.qualificationStatus === 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "warning",
                                        size: "medium"
                                      },
                                      on: { click: _vm.toSetUp }
                                    },
                                    [_vm._v("店铺审核中")]
                                  )
                                : _vm.defaultShop.qualificationStatus === 2
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger", size: "medium" },
                                      on: { click: _vm.toSetUp }
                                    },
                                    [_vm._v("店铺被驳回")]
                                  )
                                : _vm.defaultShop.audit === 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "warning",
                                        size: "medium"
                                      },
                                      on: { click: _vm.toSetUp }
                                    },
                                    [_vm._v("店铺审核中")]
                                  )
                                : _vm.defaultShop.audit === 2
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger", size: "medium" },
                                      on: { click: _vm.toSetUp }
                                    },
                                    [_vm._v("店铺被驳回")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
            ],
            2
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.setupVisible,
            width: "600px",
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.setupVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "flex pad20-b" },
            _vm._l(_vm.setupList, function(item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "setup",
                  on: {
                    click: function($event) {
                      return _vm.setupClick(item.id)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "f18 fb gray3" }, [
                    _vm._v(_vm._s(item.title))
                  ]),
                  _c("div", { staticClass: "f15 gray6 mar10-t" }, [
                    _vm._v(_vm._s(item.des))
                  ])
                ]
              )
            }),
            0
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }